









































import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  useStore,
  PropType,
  ref,
} from '@nuxtjs/composition-api'
import VueDadata from 'vue-dadata'
import { FormMask } from '@/contracts/FormMask'
import { FormInputType } from '@/contracts/FormInputType'
import { FormInputRegion } from '@/contracts/FormInput'

export default defineComponent({
  name: 'InputCity',
  components: { VueDadata },
  props: {
    type: {
      type: String as PropType<FormInputType>,
      default: FormInputType.Text,
    },
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    withBorder: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
    mask: {
      type: String as PropType<typeof FormMask>,
      default: FormMask.NotSet,
    },
    rules: {
      type: Array as PropType<string[]>,
      default: () => [''],
    },
    error: {
      type: [Boolean, String],
      default: false,
    },
    isNewStyle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit, refs, root: { $nextTick } }) {
    const store = useStore()
    const hasValue = ref(false)

    const focusInput = () => {
      $nextTick(() => {
        const dadataRef = refs.vuedadata as any
        if (dadataRef?.$refs?.inputText) {
          dadataRef.$refs.inputText.focus()
        }
      })
    }

    const inputFunc = () => {
      const dadataRef = refs.vuedadata as any
      hasValue.value = !!dadataRef?.inputQuery

      if (!dadataRef.inputQuery) {
        emit('input-change', '')
        store.commit('region/SET_REGION', null)
      } else {
        emit('input-change', { address: dadataRef.inputQuery })
      }
    }

    const focusFunc = () => emit('focus')
    const blurFunc = () => emit('blur')

    onMounted(() => {
      $nextTick(() => {
        const dadataRef = refs.vuedadata as any

        if (dadataRef?.$refs?.inputText) {
          dadataRef.$refs.inputText.addEventListener('focus', focusFunc)
          dadataRef.$refs.inputText.addEventListener('blur', blurFunc)
          dadataRef.$refs.inputText.addEventListener('input', inputFunc)
        }
      })
    })

    onBeforeUnmount(() => {
      const dadataRef = refs.vuedadata as any

      if (dadataRef?.$refs?.inputText) {
        dadataRef.$refs.inputText.removeEventListener('focus', focusFunc)
        dadataRef.$refs.inputText.removeEventListener('blur', blurFunc)
        dadataRef.$refs.inputText.removeEventListener('input', inputFunc)
      }
    })

    const onChange = (val: FormInputRegion) => {
      /* eslint-disable camelcase */
      const {
        data: {
          postal_code,
          city_with_type,
          city_kladr_id,
          region_iso_code,
          area_with_type,
          region_kladr_id,
          region_with_type,
          street,
          street_with_type,
          house_type,
          house,
          block,
          flat_type,
          flat,
          city,
          region,
          kladr_id,
          settlement_kladr_id,
        },
        unrestricted_value,
      } = val
      /* eslint-enable camelcase */

      const value = {
        postalCode: postal_code,
        region: region_iso_code,
        regionId: parseInt(region_kladr_id.slice(0, 2), 10),
        regionWithType: region_with_type,
        city: city_with_type,
        cityKladrId: city_kladr_id,
        kladr_id,
        street,
        streetWithType: street_with_type,
        houseType: house_type,
        house,
        block,
        flatType: flat_type,
        flat,
        address: unrestricted_value,
        // eslint-disable-next-line camelcase
        district: area_with_type || city_with_type,
        regionText: region,
        cityText: city,
        region_kladr_id,
        settlement_kladr_id,
        excludeError: false,
      }

      store.commit('region/SET_REGION', value?.regionWithType)
      emit('input-change', value)
    }

    return {
      onChange,
      focusInput,
      hasValue,
    }
  },
})
